// Duel skill rating per category (Elo), the competitive loop: it goes up and
// down after every duel, with tiers, and matchmaking prefers opponents near it.
export const START_RATING = 1000;
export const RATING_TIERS = [
    { name: 'Bronze', min: 0, icon: '🥉', color: '#CD7F32' },
    { name: 'Silver', min: 950, icon: '🥈', color: '#C0C0C0' },
    { name: 'Gold', min: 1150, icon: '🥇', color: '#FFC93C' },
    { name: 'Platinum', min: 1350, icon: '💠', color: '#7FDBFF' },
    { name: 'Diamond', min: 1550, icon: '💎', color: '#B388FF' },
    { name: 'Master', min: 1750, icon: '👑', color: '#FF6B6B' },
];
export function tierFor(rating) {
    let tier = RATING_TIERS[0];
    for (const t of RATING_TIERS)
        if (rating >= t.min)
            tier = t;
    return tier;
}
export function nextTier(rating) {
    const next = RATING_TIERS.find(t => t.min > rating);
    return next ? { tier: next, pointsToGo: next.min - rating } : null;
}
export function expectedScore(rating, opponent) {
    return 1 / (1 + 10 ** ((opponent - rating) / 400));
}
// New players move fast (K=40 for their first 10 duels in a category), then
// settle (K=24). A win always gains at least 1 and a loss always costs at least 1.
export function ratingDelta(rating, opponent, outcome, gamesPlayed) {
    const k = gamesPlayed < 10 ? 40 : 24;
    const actual = outcome === 'win' ? 1 : outcome === 'loss' ? 0 : 0.5;
    const delta = Math.round(k * (actual - expectedScore(rating, opponent)));
    if (outcome === 'win')
        return Math.max(1, delta);
    if (outcome === 'loss')
        return Math.min(-1, delta);
    return delta;
}
export function applyRating(rating, delta) {
    return Math.max(100, rating + delta);
}
